// adminCategoriesApi.ts
import { http } from "./http";

export type AdminCategory = {
  id: number;
  name: string;
  slug: string;
  product_count: number;
};

export type CategoryListResponse = {
  categories: AdminCategory[];
};

export type SaveCategoryPayload = {
  name: string;
  slug?: string;
};

export const getAdminCategories = async (): Promise<AdminCategory[]> => {
  const res = await http.get<CategoryListResponse>("/api/categories");
  return res.data.categories;
};

export const createAdminCategory = async (
  payload: SaveCategoryPayload
): Promise<AdminCategory> => {
  const res = await http.post<AdminCategory>("/api/categories", payload);
  return res.data;
};

export const updateAdminCategory = async (
  id: number,
  payload: SaveCategoryPayload
): Promise<AdminCategory> => {
  const res = await http.put<AdminCategory>(`/api/categories/${id}`, payload);
  return res.data;
};

export const deleteAdminCategory = async (
  id: number
): Promise<{ message: string; category: { id: number; name: string } }> => {
  const res = await http.delete(`/api/categories/${id}`);
  return res.data;
};